import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-6 bg-white',
    top: 'flex flex-col items-start gap-6 lg:flex-row lg:gap-4',
    content: '',
    photo: 'mx-auto min-h-37 min-w-37 lg:mx-0 lg:min-h-20 lg:min-w-20',
    photoImg:
      'max-h-37 max-w-37 overflow-hidden rounded-full border-[3px] border-white object-cover lg:max-h-20 lg:min-h-20 lg:max-w-20 lg:min-w-20',
    info: '',
    name: 'heading-xl mb-1',
    subtitle: 'heading-xs mb-2.5',
    experience: 'heading-xs text-secondary-hover',

    address: 'flex flex-col gap-2',
    addressTitle: 'heading-m-bold flex gap-2',
    addressText: 'heading-xs',
    addressIcon: 'text-[#BFD7F2]',
    phone: 'heading-m-bold'
  }
});
